module.exports = __webpack_public_path__ + "img/icon-exit.690cfc8b.svg";